import { Badge, Tabs } from "@mantine/core";
import { IconFileText, IconReceipt2 } from "@tabler/icons-react";
import { useCallback, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PageLayout } from "../../../components/layout";
import { ContractTab } from "./contract-tab";
import { InvoicesTab } from "./invoices-tab";

type TabValue = "contract" | "invoices";

const PlatformBilling = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab: TabValue = searchParams.get("tab") === "invoices" ? "invoices" : "contract";
  const [invoiceCount, setInvoiceCount] = useState<number | null>(null);

  const handleTabChange = (value: string | null) => {
    const next: TabValue = value === "invoices" ? "invoices" : "contract";
    setSearchParams(next === "invoices" ? { tab: "invoices" } : {}, { replace: false });
  };

  // Stable callback so the invoices tab effect does not re-fire each render.
  const handleCountChange = useCallback((count: number) => setInvoiceCount(count), []);

  return (
    <PageLayout
      title="Платформ төлбөр"
      subTitle="DeHUB-тэй байгуулсан гэрээ ба түүнээс ирсэн нэхэмжлэхүүд (зөвхөн харах)"
      extra={[
        <Badge key="ro" variant="light" color="gray" radius="sm">
          Зөвхөн харах
        </Badge>
      ]}
    >
      <Tabs value={tab} onChange={handleTabChange} keepMounted={false}>
        <Tabs.List mb="lg">
          <Tabs.Tab value="contract" leftSection={<IconFileText size={18} />}>
            Гэрээ
          </Tabs.Tab>
          <Tabs.Tab
            value="invoices"
            leftSection={<IconReceipt2 size={18} />}
            rightSection={
              invoiceCount !== null ? (
                <Badge size="sm" variant="filled" color="brand" circle>
                  {invoiceCount}
                </Badge>
              ) : null
            }
          >
            Нэхэмжлэх
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="contract">
          <ContractTab />
        </Tabs.Panel>
        <Tabs.Panel value="invoices">
          <InvoicesTab onCountChange={handleCountChange} />
        </Tabs.Panel>
      </Tabs>
    </PageLayout>
  );
};

export default PlatformBilling;
